import datetime from '../api/peer/datetime'

export default {
    methods: {
        ...datetime,
        
        showDateTime(name, value, required=false, format=null) {
            this.errors.remove(name)
            this[name] = ''
            
            if(value !== '') {
                value = this.strtotime(value)
                
                if(value === false)
                    this.errors.add(name, 'Invalid! Not able to parse the date time')
                else
                    this[name] = this.formatDisplay(value, true, format)
            }
            else if(required)
                this.errors.add(name, 'This field is required.')
        }
    }
}
